import { Controller } from "@hotwired/stimulus";

// Shows Slack required fields only when "Slack" is selected.
export default class extends Controller {
  static targets = ["select", "slackFields", "slackUserId", "slackTeamId"];

  connect() {
    this.toggle();
  }

  toggle() {
    if (!this.hasSelectTarget) return;
    const show = this.selectTarget.value === "slack";
    if (this.hasSlackFieldsTarget) {
      // Native `hidden` (UA: display:none !important) — avoids conflicts with Tailwind `.flex` + `.hidden`.
      this.slackFieldsTarget.hidden = !show;
    }
    if (this.hasSlackUserIdTarget) {
      this.slackUserIdTarget.required = show;
    }
    if (this.hasSlackTeamIdTarget) {
      this.slackTeamIdTarget.required = show;
    }
  }
}
